// extracted by mini-css-extract-plugin
module.exports = {"Question":"Question_Question__1WCx4","answers":"Question_answers__1DRVf"};